import React from "react";
import { Tooltip } from "@mui/material";

export const CustomTooltip = (props) => {
  return (
    <Tooltip
      title={<span style={{ fontSize: "1rem" }}>{props.label}</span>}
      arrow
    >
      {props.icon}
    </Tooltip>
  );
};
